import { render, staticRenderFns } from "./listDemo.vue?vue&type=template&id=51191fed&scoped=true"
import script from "./listDemo.vue?vue&type=script&lang=js"
export * from "./listDemo.vue?vue&type=script&lang=js"
import style0 from "./listDemo.vue?vue&type=style&index=0&id=51191fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51191fed",
  null
  
)

export default component.exports